<template>
	<v-card v-if="visibile" outlined class="it-card">
		<v-card-title class="text-subtitle-1 font-weight-medium pb-1">
			<v-icon small color="primary" class="mr-2">mdi-lightbulb-on-outline</v-icon>Consigli di oggi
			<v-spacer />
			<span class="it-muted">{{ summary.count }} da fare · {{ euro(summary.impact) }} stimati</span>
			<v-btn text small color="primary" class="ml-2" @click="$router.push('/insights')">Vedi tutti</v-btn>
		</v-card-title>
		<v-card-text class="pt-0">
			<div class="it-list">
				<div v-for="c in summary.top" :key="c._id" class="it-item" role="button" tabindex="0" @click="apri(c)" @keyup.enter="apri(c)">
					<v-chip x-small label outlined :color="area(c.area).colore" class="mb-1">{{ area(c.area).label }}</v-chip>
					<div class="it-title">{{ c.title }}</div>
					<div class="it-value">{{ euro(c.impact) }}</div>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { openWithReturn } from '@/components/core/pageReturn';
import { area, euro, destinazione } from './formato';

// Riquadro della Home: i tre consigli piu' importanti, solo se il modulo Consigli e' abilitato
export default {
	name: 'InsightsToday',
	computed: {
		...mapGetters({ summary: 'insights/getSummary', getPermissions: 'profile/getPermissions' }),
		abilitato() {
			const p = this.getPermissions || {};
			return !!(p.modules && p.modules.includes('pre-order.insights') && p.permissions && p.permissions.includes('pre-order.insights'));
		},
		visibile() {
			return this.abilitato && this.summary && this.summary.count > 0 && (this.summary.top || []).length > 0;
		},
	},
	mounted() {
		if (this.abilitato) this.fetchSummary().catch(() => {});
	},
	methods: {
		...mapActions({ fetchSummary: 'insights/fetchSummary' }),
		area,
		euro,
		// il riquadro porta alla pagina del consiglio; senza destinazione apre la sezione
		apri(c) {
			const dove = destinazione(c);
			if (dove) openWithReturn(this, dove, { label: 'Torna alla dashboard' });
			else this.$router.push('/insights');
		},
	},
};
</script>

<style scoped>
.it-list {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
	gap: 12px;
}
.it-item {
	border: 1px solid #e3e8ef;
	border-radius: 8px;
	padding: 10px 12px;
	cursor: pointer;
	text-align: left;
}
.it-item:hover {
	border-color: #1976d2;
}
.it-title {
	font-size: 13px;
	font-weight: 500;
	color: #1f2d3d;
}
.it-value {
	font-size: 16px;
	font-weight: 600;
	color: #1f2d3d;
	margin-top: 4px;
}
.it-muted {
	font-size: 12px;
	color: #5f6b7a;
	font-weight: 400;
}
</style>
